(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/NestedModel'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory(require('backbone-torso/modules/NestedModel'));
    } else {
      throw 'Only AMD and CommonJS imports are supported.';
    }
  }(this, function (TorsoNestedModel) {
  'use strict';

  /**
   * Model representing insurance policy information.
   * @class InsurancePolicyModel
   * @constructor
   */
  return TorsoNestedModel.extend({
    idAttribute: 'vecnaId'
  });
}));
